/**
 * O SÍMBOLO DO PORTAL (24/10/2026, escolhido pelo pesquisador entre três: a proposta A, "cartão-resposta"). Três linhas de
 * bolhas, uma marcada em cada — a folha que o portal imprime e lê pela câmera. Numa cor só (`currentColor`): quem usa diz
 * a cor. A mesma forma está no favicon (`index.html`) e nos ícones preparados para os aplicativos (`clientWeb/marca/`).
 */
export function SimboloDoPortal({ className = 'h-7 w-7' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true" focusable="false">
      <g fill="none" stroke="currentColor" strokeWidth="1.6">
        <circle cx="5" cy="5" r="2.6" /><circle cx="19" cy="5" r="2.6" />
        <circle cx="12" cy="12" r="2.6" /><circle cx="19" cy="12" r="2.6" />
        <circle cx="5" cy="19" r="2.6" /><circle cx="12" cy="19" r="2.6" />
      </g>
      <g fill="currentColor"><circle cx="12" cy="5" r="3.3" /><circle cx="5" cy="12" r="3.3" /><circle cx="19" cy="19" r="3.3" /></g>
    </svg>
  );
}
